<template>
  <div class="row animated fadeIn">
    <div class="col-md-8 offset-md-2">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-link"></i> <strong>Links</strong>
        </div>
        <div class="card-block">
          <form>
            <div class="form-group" :class="{'has-danger': errors.has('nome') }">
              <label class="col-form-label">Nome do link</label>
              <input type="text" class="form-control" name="nome" v-validate="'required'" v-model="link.name" ref='name'>
              <span v-show="errors.has('nome')" class="form-control-feedback">{{ errors.first('nome') }}</span>
            </div>
            <br/>

            <h6>Pai</h6>
            <hr />
            <div class="row">
              <div class="form-group col-md-4 input" :class="{'has-danger': errors.has('entidade pai') }">
                <label class="col-form-label">Entidade</label>
                <input type="text" class="form-control" name="entidade pai" v-validate="'required'" v-model="link.parent.entity">
                <span v-show="errors.has('entidade pai')" class="form-control-feedback">{{ errors.first('entidade pai') }}</span>
              </div>

              <div class="form-group col-md-8 input" :class="{'has-danger': errors.has('id pai') }">
                <label class="col-form-label">Id</label>
                <input type="text" class="form-control" name="id pai" v-validate="'required'" v-model="link.parent.id">
                <span v-show="errors.has('id pai')" class="form-control-feedback">{{ errors.first('id pai') }}</span>
              </div>
            </div>
            <br/>

            <h6>Filho</h6>
            <hr />
            <div class="row">
              <div class="form-group col-md-4 input" :class="{'has-danger': errors.has('entidade filho') }">
                <label class="col-form-label">Entidade</label>
                <input type="text" class="form-control" name="entidade filho" v-validate="'required'" v-model="link.child.entity">
                <span v-show="errors.has('entidade filho')" class="form-control-feedback">{{ errors.first('entidade filho') }}</span>
              </div>

              <div class="form-group col-md-8 input" :class="{'has-danger': errors.has('id filho') }">
                <label class="col-form-label">Id</label>
                <input type="text" class="form-control" name="id filho" v-validate="'required'" v-model="link.child.id">
                <span v-show="errors.has('id filho')" class="form-control-feedback">{{ errors.first('id filho') }}</span>
              </div>
            </div>
          </form>
        </div>
        <div class="card-footer">
          <div class="pull-right">
            <button type="button" class="btn btn-link" @click.prevent="reset" style="text-decoration: none;">
              <i class="fa fa-eraser"></i> Cancelar
            </button>
            <button type="button" class="btn btn-sm btn-secondary" @click.prevent="save">
              <i class="fa fa-save"></i> Criar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'links',
  components: { },
  data () {
    return {
      link: {
        name: '',
        parent: {
          id: '', entity: ''
        },
        child: {
          id: '', entity: ''
        }
      }
    }
  },
  created () {
  },
  methods: {
    reset() {
      this.link.name = ''
      this.link.parent.id = ''
      this.link.parent.entity = ''
      this.link.child.id = ''
      this.link.child.entity = ''
      this.errors.clear()
    },
    save() {
      this.$validator.validateAll()
      if (!this.errors.any()) {
        axios.post(`${process.env.API_URL}cerebro/links`, this.link).then(response => {
          this.showSuccess('Link criado com sucesso.')
          this.reset()
          this.errors.clear()
        }).catch(err => {
          console.log(err.response)
          this.showError('Ops. Ocorreu um erro ao criar o link.')
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Index.vue?3515bf46